var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadSlateBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6026 12.75V17.3177H3.63069V12.75H0.945312V18.6604C0.945312 19.4014 1.54562 20.0024 2.29 20.0024H18.9432C19.687 20.0024 20.2879 19.4021 20.2879 18.6604V12.75H17.6026Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.364 12.2903L6.51939 7.6446C6.51939 7.6446 5.93443 7.09232 6.56875 7.09232C7.20308 7.09232 8.7352 7.09232 8.7352 7.09232C8.7352 7.09232 8.7352 6.72079 8.7352 6.14783C8.7352 4.51432 8.7352 1.54146 8.7352 0.329503C8.7352 0.329503 8.64916 0 9.14541 0C9.64567 0 11.8368 0 12.195 0C12.5525 0 12.5445 0.277476 12.5445 0.277476C12.5445 1.45275 12.5445 4.52833 12.5445 6.10848C12.5445 6.62074 12.5445 6.95291 12.5445 6.95291C12.5445 6.95291 13.7731 6.95291 14.5442 6.95291C15.3139 6.95291 14.7343 7.53121 14.7343 7.53121C14.7343 7.53121 11.4633 11.8734 11.007 12.329C10.6789 12.6592 10.364 12.2903 10.364 12.2903Z",
    fill: "#2C3E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSlateBlue);
export default __webpack_public_path__ + "static/media/download-slate-blue.2445f8f4fb68e016111c32fc2afad367.svg";
export { ForwardRef as ReactComponent };